export const NATURE_OF_BUSINESS = [
  ['Accommodation', 'accommodation'],
  ['Food Service', 'food_service'],
  ['Administrative Management', 'administrative_management'],
  ['Support Management', 'support_management'],
  ['Waste Management', 'waste_management'],
  ['Remediation Services', 'remediation_services'],
  /* ['Adult Entertainment', 'adult_entertainment'],*/
  ['Agriculture', 'agriculture'],
  ['Forestry', 'forestry'],
  ['Fishing And Hunting', 'fishing_and_hunting'],
  ['Art', 'art'],
  ['Entertainment', 'entertainment'],
  ['Recreation', 'recreation'],
  ['Construction', 'construction'],
  ['Crypto Exchange', 'crypto_exchange'],
  ['Crypto Broker', 'crypto_broker'],
  ['Crypto ATM', 'crypto_atm'],
  ['Crypto Mining', 'crypto_mining'],
  ['Proprietary Crypto Trader', 'proprietary_crypto_trader'],
  ['Algorithm Crypto Trader', 'algorithm_crypto_trader'],
  ['P2P Merchant', 'p2p_merchant'],
  ['Other Digital Asset Service Provider', 'other_digital_asset_service_provider'],
  ['Bank', 'bank'],
  ['Non Bank Financial Institution', 'non_bank_financial_institution'],
  ['Money Services Business', 'money_services_business'],
  ['Payment Service Provider', 'payment_service_provider'],
  ['Family Office', 'family_office'],
  ['Personal Investment Company', 'personal_investment_company'],
  ['Superannuation Fund', 'superannuation_fund'],
  ['Sovereign Wealth Fund', 'sovereign_wealth_fund'],
  ['Investment Fund', 'investment_fund'],
  ['Educational Service', 'educational_service'],
  /* ['Firearms And Weapons', 'firearms_and_weapons'],*/
  ['Betting', 'betting'],
  ['Health Care', 'health_care'],
  ['Social Assistance', 'social_assistance'],
  ['Information', 'information'],
  ['General Wholesaler', 'general_wholesaler'],
  ['Management', 'management'],
  ['Precious Stones And Precious Metals Dealer', 'precious_stones_and_precious_metals_dealer'],
  ['Crude Oil Dealer', 'crude_oil_dealer'],
  ['Natural Gas Dealer', 'natural_gas_dealer'],
  ['General Manufacturing', 'general_manufacturing'],
  ['Marijuana', 'marijuana'],
  ['Mining And Extraction', 'mining_and_extraction'],
  ['Pawn Shop', 'pawn_shop'],
  ['Professional Service', 'professional_service'],
  ['Scientific And Technical Service', 'scientific_and_technical_service'],
  ['Public Administration', 'public_administration'],
  ['Real Estate Rental And Leasing', 'real_estate_rental_and_leasing'],
  ['Retail Store Electronics', 'retail_store_electronics'],
  ['Retail Store Food Beverages', 'retail_store_food_beverages'],
  ['Retail Store Jewelry', 'retail_store_jewelry'],
  ['Retail Trade Others', 'retail_trade_others'],
  ['Sale Of Drugs And Pharmaceutical Products', 'sale_of_drugs_and_pharmaceutical_products'],
  ['Tobacco', 'tobacco'],
  ['Transportation And Warehousing', 'transportation_and_warehousing'],
  ['Utilities', 'utilities'],
  ['Other', 'other'],
];
